(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function() {
    const container = document.querySelector('.accelerated-checkout-block[data-button-text]');
    if (!container) return;

    const customButtonText = container.getAttribute('data-button-text');
    if (!customButtonText) return;

    // Funktion zum Ändern des Button-Texts
    function updateButtonText() {
      const button = container.querySelector('button.shopify-payment-button__button--unbranded');
      if (button && button.textContent.trim() !== customButtonText) {
        button.textContent = customButtonText;
      }
    }

    // Sofort versuchen, falls Button bereits vorhanden ist
    updateButtonText();

    // MutationObserver, um Änderungen am DOM zu überwachen
    const observer = new MutationObserver(function(mutations) {
      updateButtonText();
    });

    // Beobachte Änderungen im Container
    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Zusätzlich: Event-Listener für Shopify-spezifische Events
    container.addEventListener('DOMContentLoaded', updateButtonText);
    document.addEventListener('DOMContentLoaded', updateButtonText);
    
    // Fallback: Regelmäßig prüfen (falls Button verzögert geladen wird)
    const interval = setInterval(function() {
      const button = container.querySelector('button.shopify-payment-button__button--unbranded');
      if (button) {
        updateButtonText();
        clearInterval(interval);
      }
    }, 100);

    // Nach 5 Sekunden aufhören zu prüfen
    setTimeout(function() {
      clearInterval(interval);
    }, 5000);
  })();

  (function () {
    function findMoreOptionsLink(block) {
      return (
        block.querySelector('more-payment-options-link a') ||
        block.querySelector('a#more-payment-options-link') ||
        block.querySelector('a.shopify-payment-button__more-options')
      );
    }

    function syncProxyVisibility(block) {
      var proxy = block.querySelector('[data-accelerated-checkout-proxy]');
      if (!proxy) return;
      var link = findMoreOptionsLink(block);
      if (!link || link.getAttribute('aria-hidden') === 'true') {
        proxy.hidden = true;
      } else {
        proxy.hidden = false;
      }
    }

    function syncAllBlocks() {
      document.querySelectorAll('.accelerated-checkout-block').forEach(syncProxyVisibility);
    }

    document.addEventListener('click', function (e) {
      var proxy = e.target.closest('[data-accelerated-checkout-proxy]');
      if (!proxy) return;
      e.preventDefault();
      var block = proxy.closest('.accelerated-checkout-block');
      if (!block) return;
      var link = findMoreOptionsLink(block);
      if (link && link.getAttribute('aria-hidden') !== 'true') {
        link.click();
        return;
      }
      var fallback = block.getAttribute('data-checkout-fallback');
      window.location.href = fallback && fallback.length ? fallback : '/checkout';
    });

    var debounceTimer;
    function scheduleSync() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncAllBlocks, 32);
    }

    syncAllBlocks();
    document.addEventListener('DOMContentLoaded', syncAllBlocks);
    document.addEventListener('shopify:section:load', syncAllBlocks);

    if (document.body) {
      new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
    }

    var n = 0;
    var iv = setInterval(function () {
      syncAllBlocks();
      n += 1;
      if (n >= 50) clearInterval(iv);
    }, 200);
  })();
  } catch(e) { console.error(e); }
})();

})();
